// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.container-flash-border{
    border-radius: 15px;
}

.container-flash-border .flash-border {
    width: 106px; /* Ajusta el tamaño según sea necesario */
    position: absolute;
    top: -25px; /* Ajusta la posición inicial para que la imagen esté fuera del borde */
    left: -44px;
    animation: flashBorder 10s linear 1;
}

@keyframes flashBorder {

    0% {
        top: calc(100% - 45px);
        left: -44px;
        transform: rotate(270deg);
        opacity: 0;
    }
    5% {
        top: calc(80% - 45px);
        left: -44px;
        transform: rotate(270deg);
        opacity: 1;
    }
    20% {
        top: calc(20% - 45px);
        left: -44px;
        transform: rotate(270deg);
        opacity: 0;
    }
    24.9% {
        top: -31px;
        left: -44px;
        transform: rotate(0deg);
        opacity: 0;
    }
    25% {
        top: -31px;
        left: -44px;
        transform: rotate(0deg);
        opacity: 0;
    }
    30% {
        top: -31px;
        left: calc(20% - 61px);
        transform: rotate(0deg);
        opacity: 1;
    }

    45% {
        top: -31px;
        left: calc(80% - 61px);
        transform: rotate(0deg);
        opacity: 0;
    }
    49.9% {
        top: -31px;
        left: calc(100% - 61px);
        transform: rotate(0deg);
        opacity: 0;
    }
    50% {
        top: -31px;
        left: calc(100% - 61px);
        transform: rotate(90deg);
        opacity: 0;
    }
    55% {
        top: calc(40% - 45px);
        left: calc(100% - 61px);
        transform: rotate(90deg);
        opacity: 0;
    }
    65% {
        top: calc(75% - 45px);
        left: calc(100% - 61px);
        transform: rotate(90deg);
        opacity: 1;
    }
    74.9% {
        top: calc(100% - 45px);
        left: calc(100% - 61px);
        transform: rotate(90deg);
        opacity: 0;
    }
    75% {
        top: calc(100% - 45px);
        left: calc(100% - 61px);
        transform: rotate(90deg);
        opacity: 0;
    }
    80% {
        top: calc(100% - 45px);
        left: calc(100% - 33px);
        transform: rotate(180deg);
        opacity: 0;
    }
    95% {
        top: calc(100% - 45px);
        left: calc(80% - 59px);
        transform: rotate(180deg);
        opacity: 0;
    }
    99.9% {
        top: calc(100% - 45px);
        left: calc(20% - 59px);
        transform: rotate(180deg);
        opacity: 0;
    }
    100% {
        top: calc(100% - 45px);
        left: -42px;
        transform: rotate(180deg);
        opacity: 0;
    }






}

/*.container-flash-border .flash-border-2 {*/
/*    width: 100px; !* Ajusta el tamaño según sea necesario *!*/
/*    position: absolute;*/
/*    top: -29px;*/
/*    left: calc(100% - 59px);*/
/*    animation: flashBorder2 3s linear 1;*/

/*}*/

/*.container-flash-border .flash-border-3 {*/
/*    width: 100px; !* Ajusta el tamaño según sea necesario *!*/
/*    position: absolute;*/
/*    top: calc(100% - 46px);*/
/*    left: calc(100% - 33px);*/
/*    animation: flashBorder3 3s linear 1;*/

/*}*/

@keyframes flashBorder1 {
    0% {
        top: -29px;
        left: -41px;
        transform: rotate(0deg);
        opacity: 0;
    }
    5% {
        top: -29px;
        left: calc(20% - 59px);
        transform: rotate(0deg);
        opacity: 1;
    }
    20% {
        top: -29px;
        left: calc(80% - 59px);
        transform: rotate(0deg);
        opacity: 0;
    }
    24.9% {
        top: -29px;
        left: calc(100% - 59px);
        transform: rotate(0deg);
        opacity: 0;
    }
    25% {
        top: -29px;
        left: calc(100% - 59px);
        transform: rotate(90deg);
        opacity: 0;
    }
    30% {
        top: calc(20% - 46px);
        left: calc(100% - 59px);
        transform: rotate(90deg);
        opacity: 1;
    }
    45% {
        top: calc(80% - 46px);
        left: calc(100% - 59px);
        transform: rotate(90deg);
        opacity: 0;
    }
    49.9% {
        top: calc(100% - 46px);
        left: calc(100% - 59px);
        transform: rotate(90deg);
        opacity: 0;
    }
    50% {
        top: calc(100% - 46px);
        left: calc(100% - 33px);
        transform: rotate(180deg);
        opacity: 0;
    }
    55% {
        top: calc(100% - 46px);
        left: calc(80% - 59px);
        transform: rotate(180deg);
        opacity: 1;
    }
    70% {
        top: calc(100% - 46px);
        left: calc(20% - 59px);
        transform: rotate(180deg);
        opacity: 0;
    }
    74.9% {
        top: calc(100% - 46px);
        left: -41px;
        transform: rotate(180deg);
        opacity: 0;
    }
    75% {
        top: calc(100% - 46px);
        left: -41px;
        transform: rotate(270deg);
        opacity: 0;
    }
    80% {
        top: calc(80% - 46px);
        left: -41px;
        transform: rotate(270deg);
        opacity: 1;
    }
    95% {
        top: calc(20% - 46px);
        left: -41px;
        transform: rotate(270deg);
        opacity: 0;
    }
    99.9% {
        top: -29px;
        left: -41px;
        transform: rotate(270deg);
        opacity: 0;
    }
    100% {
        top: -29px;
        left: -41px;
        transform: rotate(360deg);
        opacity: 0;
    }
}

@keyframes flashBorder2 {

    0% {
        top: -29px;
        left: calc(100% - 59px);
        transform: rotate(90deg);
        opacity: 0;
    }
    5% {
        top: calc(20% - 46px);
        left: calc(100% - 59px);
        transform: rotate(90deg);
        opacity: 1;
    }
    20% {
        top: calc(80% - 46px);
        left: calc(100% - 59px);
        transform: rotate(90deg);
        opacity: 0;
    }
    24.9% {
        top: calc(100% - 46px);
        left: calc(100% - 59px);
        transform: rotate(90deg);
        opacity: 0;
    }
    25% {
        top: calc(100% - 46px);
        left: calc(100% - 33px);
        transform: rotate(180deg);
        opacity: 0;
    }
    30% {
        top: calc(100% - 46px);
        left: calc(80% - 59px);
        transform: rotate(180deg);
        opacity: 1;
    }
    45% {
        top: calc(100% - 46px);
        left: calc(20% - 59px);
        transform: rotate(180deg);
        opacity: 0;
    }
    49.9% {
        top: calc(100% - 46px);
        left: -41px;
        transform: rotate(270deg);
        opacity: 0;
    }
    50% {
        top: calc(100% - 46px);
        left: -41px;
        transform: rotate(270deg);
        opacity: 0;
    }
    55% {
        top: calc(80% - 46px);
        left: -41px;
        transform: rotate(270deg);
        opacity: 1;
    }
    70% {
        top: calc(20% - 46px);
        left: -41px;
        transform: rotate(270deg);
        opacity: 0;
    }
    74.9% {
        top: -29px;
        left: -41px;
        transform: rotate(360deg);
        opacity: 0;
    }
    75% {
        top: -29px;
        left: -41px;
        transform: rotate(360deg);
        opacity: 0;
    }

    80% {
        top: -29px;
        left: calc(20% - 59px);
        transform: rotate(360deg);
        opacity: 1;
    }
    95% {
        top: -29px;
        left: calc(80% - 59px);
        transform: rotate(360deg);
        opacity: 0;
    }
    99.9% {
        top: -29px;
        left: calc(80% - 59px);
        transform: rotate(90deg);
        opacity: 0;
    }
    100% {
        top: -29px;
        left: calc(100% - 59px);
        transform: rotate(90deg);
        opacity: 0;
    }
}

@keyframes flashBorder3 {

    0% {
        top: calc(100% - 46px);
        left: calc(100% - 33px);
        transform: rotate(180deg);
        opacity: 0;
    }
    5% {
        top: calc(100% - 46px);
        left: calc(80% - 59px);
        transform: rotate(180deg);
        opacity: 1;
    }
    20% {
        top: calc(100% - 46px);
        left: calc(20% - 59px);
        transform: rotate(180deg);
        opacity: 0;
    }
    24.9% {
        top: calc(100% - 46px);
        left: -41px;
        transform: rotate(180deg);
        opacity: 0;
    }
    25% {
        top: calc(100% - 46px);
        left: -41px;
        transform: rotate(270deg);
        opacity: 0;
    }
    30% {
        top: calc(80% - 46px);
        left: -41px;
        transform: rotate(270deg);
        opacity: 1;
    }
    45% {
        top: calc(20% - 46px);
        left: -41px;
        transform: rotate(270deg);
        opacity: 0;
    }
    49.9% {
        top: -29px;
        left: -41px;
        transform: rotate(270deg);
        opacity: 0;
    }
    50% {
        top: -29px;
        left: -41px;
        transform: rotate(360deg);
        opacity: 0;
    }
    55% {
        top: -29px;
        left: calc(20% - 59px);
        transform: rotate(360deg);
        opacity: 1;
    }
    70% {
        top: -29px;
        left: calc(80% - 59px);
        transform: rotate(360deg);
        opacity: 0;
    }
    74.9% {
        top: -29px;
        left: calc(100% - 59px);
        transform: rotate(90deg);
        opacity: 0;
    }
    75% {
        top: -29px;
        left: calc(100% - 59px);
        transform: rotate(90deg);
        opacity: 0;
    }
    80% {
        top: calc(20% - 46px);
        left: calc(100% - 59px);
        transform: rotate(90deg);
        opacity: 1;
    }
    95% {
        top: calc(80% - 46px);
        left: calc(100% - 59px);
        transform: rotate(90deg);
        opacity: 0;
    }
    99.9% {
        top: calc(100% - 46px);
        left: calc(100% - 59px);
        transform: rotate(180deg);
        opacity: 0;
    }
    100% {
        top: calc(100% - 46px);
        left: calc(100% - 59px);
        transform: rotate(180deg);
        opacity: 0;
    }
}

`, "",{"version":3,"sources":["webpack://./src/css/flashing-border.css"],"names":[],"mappings":";AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY,EAAE,yCAAyC;IACvD,kBAAkB;IAClB,UAAU,EAAE,uEAAuE;IACnF,WAAW;IACX,mCAAmC;AACvC;;AAEA;;IAEI;QACI,sBAAsB;QACtB,WAAW;QACX,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,WAAW;QACX,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,WAAW;QACX,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,UAAU;QACV,WAAW;QACX,uBAAuB;QACvB,UAAU;IACd;IACA;QACI,UAAU;QACV,WAAW;QACX,uBAAuB;QACvB,UAAU;IACd;IACA;QACI,UAAU;QACV,sBAAsB;QACtB,uBAAuB;QACvB,UAAU;IACd;;IAEA;QACI,UAAU;QACV,sBAAsB;QACtB,uBAAuB;QACvB,UAAU;IACd;IACA;QACI,UAAU;QACV,uBAAuB;QACvB,uBAAuB;QACvB,UAAU;IACd;IACA;QACI,UAAU;QACV,uBAAuB;QACvB,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,uBAAuB;QACvB,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,uBAAuB;QACvB,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,sBAAsB;QACtB,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,sBAAsB;QACtB,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,WAAW;QACX,yBAAyB;QACzB,UAAU;IACd;;;;;;;AAOJ;;AAEA,4CAA4C;AAC5C,+DAA+D;AAC/D,0BAA0B;AAC1B,kBAAkB;AAClB,+BAA+B;AAC/B,2CAA2C;;AAE3C,IAAI;;AAEJ,4CAA4C;AAC5C,+DAA+D;AAC/D,0BAA0B;AAC1B,8BAA8B;AAC9B,+BAA+B;AAC/B,2CAA2C;;AAE3C,IAAI;;AAEJ;IACI;QACI,UAAU;QACV,WAAW;QACX,uBAAuB;QACvB,UAAU;IACd;IACA;QACI,UAAU;QACV,sBAAsB;QACtB,uBAAuB;QACvB,UAAU;IACd;IACA;QACI,UAAU;QACV,sBAAsB;QACtB,uBAAuB;QACvB,UAAU;IACd;IACA;QACI,UAAU;QACV,uBAAuB;QACvB,uBAAuB;QACvB,UAAU;IACd;IACA;QACI,UAAU;QACV,uBAAuB;QACvB,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,uBAAuB;QACvB,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,uBAAuB;QACvB,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,sBAAsB;QACtB,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,sBAAsB;QACtB,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,WAAW;QACX,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,WAAW;QACX,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,WAAW;QACX,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,WAAW;QACX,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,UAAU;QACV,WAAW;QACX,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,UAAU;QACV,WAAW;QACX,yBAAyB;QACzB,UAAU;IACd;AACJ;;AAEA;;IAEI;QACI,UAAU;QACV,uBAAuB;QACvB,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,uBAAuB;QACvB,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,uBAAuB;QACvB,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,sBAAsB;QACtB,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,sBAAsB;QACtB,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,WAAW;QACX,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,WAAW;QACX,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,WAAW;QACX,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,WAAW;QACX,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,UAAU;QACV,WAAW;QACX,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,UAAU;QACV,WAAW;QACX,yBAAyB;QACzB,UAAU;IACd;;IAEA;QACI,UAAU;QACV,sBAAsB;QACtB,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,UAAU;QACV,sBAAsB;QACtB,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,UAAU;QACV,sBAAsB;QACtB,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,UAAU;QACV,uBAAuB;QACvB,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;;IAEI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,sBAAsB;QACtB,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,sBAAsB;QACtB,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,WAAW;QACX,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,WAAW;QACX,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,WAAW;QACX,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,WAAW;QACX,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,UAAU;QACV,WAAW;QACX,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,UAAU;QACV,WAAW;QACX,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,UAAU;QACV,sBAAsB;QACtB,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,UAAU;QACV,sBAAsB;QACtB,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,UAAU;QACV,uBAAuB;QACvB,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,UAAU;QACV,uBAAuB;QACvB,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,uBAAuB;QACvB,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,uBAAuB;QACvB,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,yBAAyB;QACzB,UAAU;IACd;IACA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,yBAAyB;QACzB,UAAU;IACd;AACJ","sourcesContent":["\n.container-flash-border{\n    border-radius: 15px;\n}\n\n.container-flash-border .flash-border {\n    width: 106px; /* Ajusta el tamaño según sea necesario */\n    position: absolute;\n    top: -25px; /* Ajusta la posición inicial para que la imagen esté fuera del borde */\n    left: -44px;\n    animation: flashBorder 10s linear 1;\n}\n\n@keyframes flashBorder {\n\n    0% {\n        top: calc(100% - 45px);\n        left: -44px;\n        transform: rotate(270deg);\n        opacity: 0;\n    }\n    5% {\n        top: calc(80% - 45px);\n        left: -44px;\n        transform: rotate(270deg);\n        opacity: 1;\n    }\n    20% {\n        top: calc(20% - 45px);\n        left: -44px;\n        transform: rotate(270deg);\n        opacity: 0;\n    }\n    24.9% {\n        top: -31px;\n        left: -44px;\n        transform: rotate(0deg);\n        opacity: 0;\n    }\n    25% {\n        top: -31px;\n        left: -44px;\n        transform: rotate(0deg);\n        opacity: 0;\n    }\n    30% {\n        top: -31px;\n        left: calc(20% - 61px);\n        transform: rotate(0deg);\n        opacity: 1;\n    }\n\n    45% {\n        top: -31px;\n        left: calc(80% - 61px);\n        transform: rotate(0deg);\n        opacity: 0;\n    }\n    49.9% {\n        top: -31px;\n        left: calc(100% - 61px);\n        transform: rotate(0deg);\n        opacity: 0;\n    }\n    50% {\n        top: -31px;\n        left: calc(100% - 61px);\n        transform: rotate(90deg);\n        opacity: 0;\n    }\n    55% {\n        top: calc(40% - 45px);\n        left: calc(100% - 61px);\n        transform: rotate(90deg);\n        opacity: 0;\n    }\n    65% {\n        top: calc(75% - 45px);\n        left: calc(100% - 61px);\n        transform: rotate(90deg);\n        opacity: 1;\n    }\n    74.9% {\n        top: calc(100% - 45px);\n        left: calc(100% - 61px);\n        transform: rotate(90deg);\n        opacity: 0;\n    }\n    75% {\n        top: calc(100% - 45px);\n        left: calc(100% - 61px);\n        transform: rotate(90deg);\n        opacity: 0;\n    }\n    80% {\n        top: calc(100% - 45px);\n        left: calc(100% - 33px);\n        transform: rotate(180deg);\n        opacity: 0;\n    }\n    95% {\n        top: calc(100% - 45px);\n        left: calc(80% - 59px);\n        transform: rotate(180deg);\n        opacity: 0;\n    }\n    99.9% {\n        top: calc(100% - 45px);\n        left: calc(20% - 59px);\n        transform: rotate(180deg);\n        opacity: 0;\n    }\n    100% {\n        top: calc(100% - 45px);\n        left: -42px;\n        transform: rotate(180deg);\n        opacity: 0;\n    }\n\n\n\n\n\n\n}\n\n/*.container-flash-border .flash-border-2 {*/\n/*    width: 100px; !* Ajusta el tamaño según sea necesario *!*/\n/*    position: absolute;*/\n/*    top: -29px;*/\n/*    left: calc(100% - 59px);*/\n/*    animation: flashBorder2 3s linear 1;*/\n\n/*}*/\n\n/*.container-flash-border .flash-border-3 {*/\n/*    width: 100px; !* Ajusta el tamaño según sea necesario *!*/\n/*    position: absolute;*/\n/*    top: calc(100% - 46px);*/\n/*    left: calc(100% - 33px);*/\n/*    animation: flashBorder3 3s linear 1;*/\n\n/*}*/\n\n@keyframes flashBorder1 {\n    0% {\n        top: -29px;\n        left: -41px;\n        transform: rotate(0deg);\n        opacity: 0;\n    }\n    5% {\n        top: -29px;\n        left: calc(20% - 59px);\n        transform: rotate(0deg);\n        opacity: 1;\n    }\n    20% {\n        top: -29px;\n        left: calc(80% - 59px);\n        transform: rotate(0deg);\n        opacity: 0;\n    }\n    24.9% {\n        top: -29px;\n        left: calc(100% - 59px);\n        transform: rotate(0deg);\n        opacity: 0;\n    }\n    25% {\n        top: -29px;\n        left: calc(100% - 59px);\n        transform: rotate(90deg);\n        opacity: 0;\n    }\n    30% {\n        top: calc(20% - 46px);\n        left: calc(100% - 59px);\n        transform: rotate(90deg);\n        opacity: 1;\n    }\n    45% {\n        top: calc(80% - 46px);\n        left: calc(100% - 59px);\n        transform: rotate(90deg);\n        opacity: 0;\n    }\n    49.9% {\n        top: calc(100% - 46px);\n        left: calc(100% - 59px);\n        transform: rotate(90deg);\n        opacity: 0;\n    }\n    50% {\n        top: calc(100% - 46px);\n        left: calc(100% - 33px);\n        transform: rotate(180deg);\n        opacity: 0;\n    }\n    55% {\n        top: calc(100% - 46px);\n        left: calc(80% - 59px);\n        transform: rotate(180deg);\n        opacity: 1;\n    }\n    70% {\n        top: calc(100% - 46px);\n        left: calc(20% - 59px);\n        transform: rotate(180deg);\n        opacity: 0;\n    }\n    74.9% {\n        top: calc(100% - 46px);\n        left: -41px;\n        transform: rotate(180deg);\n        opacity: 0;\n    }\n    75% {\n        top: calc(100% - 46px);\n        left: -41px;\n        transform: rotate(270deg);\n        opacity: 0;\n    }\n    80% {\n        top: calc(80% - 46px);\n        left: -41px;\n        transform: rotate(270deg);\n        opacity: 1;\n    }\n    95% {\n        top: calc(20% - 46px);\n        left: -41px;\n        transform: rotate(270deg);\n        opacity: 0;\n    }\n    99.9% {\n        top: -29px;\n        left: -41px;\n        transform: rotate(270deg);\n        opacity: 0;\n    }\n    100% {\n        top: -29px;\n        left: -41px;\n        transform: rotate(360deg);\n        opacity: 0;\n    }\n}\n\n@keyframes flashBorder2 {\n\n    0% {\n        top: -29px;\n        left: calc(100% - 59px);\n        transform: rotate(90deg);\n        opacity: 0;\n    }\n    5% {\n        top: calc(20% - 46px);\n        left: calc(100% - 59px);\n        transform: rotate(90deg);\n        opacity: 1;\n    }\n    20% {\n        top: calc(80% - 46px);\n        left: calc(100% - 59px);\n        transform: rotate(90deg);\n        opacity: 0;\n    }\n    24.9% {\n        top: calc(100% - 46px);\n        left: calc(100% - 59px);\n        transform: rotate(90deg);\n        opacity: 0;\n    }\n    25% {\n        top: calc(100% - 46px);\n        left: calc(100% - 33px);\n        transform: rotate(180deg);\n        opacity: 0;\n    }\n    30% {\n        top: calc(100% - 46px);\n        left: calc(80% - 59px);\n        transform: rotate(180deg);\n        opacity: 1;\n    }\n    45% {\n        top: calc(100% - 46px);\n        left: calc(20% - 59px);\n        transform: rotate(180deg);\n        opacity: 0;\n    }\n    49.9% {\n        top: calc(100% - 46px);\n        left: -41px;\n        transform: rotate(270deg);\n        opacity: 0;\n    }\n    50% {\n        top: calc(100% - 46px);\n        left: -41px;\n        transform: rotate(270deg);\n        opacity: 0;\n    }\n    55% {\n        top: calc(80% - 46px);\n        left: -41px;\n        transform: rotate(270deg);\n        opacity: 1;\n    }\n    70% {\n        top: calc(20% - 46px);\n        left: -41px;\n        transform: rotate(270deg);\n        opacity: 0;\n    }\n    74.9% {\n        top: -29px;\n        left: -41px;\n        transform: rotate(360deg);\n        opacity: 0;\n    }\n    75% {\n        top: -29px;\n        left: -41px;\n        transform: rotate(360deg);\n        opacity: 0;\n    }\n\n    80% {\n        top: -29px;\n        left: calc(20% - 59px);\n        transform: rotate(360deg);\n        opacity: 1;\n    }\n    95% {\n        top: -29px;\n        left: calc(80% - 59px);\n        transform: rotate(360deg);\n        opacity: 0;\n    }\n    99.9% {\n        top: -29px;\n        left: calc(80% - 59px);\n        transform: rotate(90deg);\n        opacity: 0;\n    }\n    100% {\n        top: -29px;\n        left: calc(100% - 59px);\n        transform: rotate(90deg);\n        opacity: 0;\n    }\n}\n\n@keyframes flashBorder3 {\n\n    0% {\n        top: calc(100% - 46px);\n        left: calc(100% - 33px);\n        transform: rotate(180deg);\n        opacity: 0;\n    }\n    5% {\n        top: calc(100% - 46px);\n        left: calc(80% - 59px);\n        transform: rotate(180deg);\n        opacity: 1;\n    }\n    20% {\n        top: calc(100% - 46px);\n        left: calc(20% - 59px);\n        transform: rotate(180deg);\n        opacity: 0;\n    }\n    24.9% {\n        top: calc(100% - 46px);\n        left: -41px;\n        transform: rotate(180deg);\n        opacity: 0;\n    }\n    25% {\n        top: calc(100% - 46px);\n        left: -41px;\n        transform: rotate(270deg);\n        opacity: 0;\n    }\n    30% {\n        top: calc(80% - 46px);\n        left: -41px;\n        transform: rotate(270deg);\n        opacity: 1;\n    }\n    45% {\n        top: calc(20% - 46px);\n        left: -41px;\n        transform: rotate(270deg);\n        opacity: 0;\n    }\n    49.9% {\n        top: -29px;\n        left: -41px;\n        transform: rotate(270deg);\n        opacity: 0;\n    }\n    50% {\n        top: -29px;\n        left: -41px;\n        transform: rotate(360deg);\n        opacity: 0;\n    }\n    55% {\n        top: -29px;\n        left: calc(20% - 59px);\n        transform: rotate(360deg);\n        opacity: 1;\n    }\n    70% {\n        top: -29px;\n        left: calc(80% - 59px);\n        transform: rotate(360deg);\n        opacity: 0;\n    }\n    74.9% {\n        top: -29px;\n        left: calc(100% - 59px);\n        transform: rotate(90deg);\n        opacity: 0;\n    }\n    75% {\n        top: -29px;\n        left: calc(100% - 59px);\n        transform: rotate(90deg);\n        opacity: 0;\n    }\n    80% {\n        top: calc(20% - 46px);\n        left: calc(100% - 59px);\n        transform: rotate(90deg);\n        opacity: 1;\n    }\n    95% {\n        top: calc(80% - 46px);\n        left: calc(100% - 59px);\n        transform: rotate(90deg);\n        opacity: 0;\n    }\n    99.9% {\n        top: calc(100% - 46px);\n        left: calc(100% - 59px);\n        transform: rotate(180deg);\n        opacity: 0;\n    }\n    100% {\n        top: calc(100% - 46px);\n        left: calc(100% - 59px);\n        transform: rotate(180deg);\n        opacity: 0;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
